import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

export const EventLink = ({ event, settings, className = '' }) => {
  const eventUrl = event.get('venue_website');
  const linkText = settings.get('eventLinkText', '');

  // Don't render if link text is null or blank
  if (!linkText || linkText.trim() === '') {
    return null;
  }

  // Don't render if no URL is available
  if (!eventUrl) {
    return null;
  }

  const handleClick = (e) => {
    e.preventDefault();
    window.open(eventUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <a href={eventUrl} onClick={handleClick} className={cn(className, 'event-link')} target="_blank" rel="noopener noreferrer">
      {linkText}
    </a>
  );
};

EventLink.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
};
